import { ObservableMap } from "mobx";
import { NetworkRequestStatistics } from "../../State/EvidenceDB/DatabaseTypes";



export interface SourcePageAndDestinationPageUrlRequestStatistics extends NetworkRequestStatistics {
	sourcePageUrl: string;
	destinationPageUrl: string;
}


export interface UrlRequestStatistics extends NetworkRequestStatistics {
	url: string;
}

export interface DomainRequestStatistics extends NetworkRequestStatistics {
	domain: string;
}
export interface StatisticsNodeForRequestsForDomainNode extends DomainRequestStatistics {
	urls: Map<string, UrlRequestStatistics> | ObservableMap<string, UrlRequestStatistics>;
}

export interface NetworkStatisticsForRequestsForRegisteredDomain extends NetworkRequestStatistics {
	registeredDomain: string;
}

export interface NetworkStatisticsNodeForRequestsForRegisteredDomain extends NetworkStatisticsForRequestsForRegisteredDomain {
	domains: Map<string, StatisticsNodeForRequestsForDomainNode> | ObservableMap<string, StatisticsNodeForRequestsForDomainNode>;
}

export type NetworkOriginStatisticsTree = Map<string, NetworkStatisticsNodeForRequestsForRegisteredDomain> |
	ObservableMap<string, NetworkStatisticsNodeForRequestsForRegisteredDomain>;

export interface NetworkStatisticsTree extends NetworkRequestStatistics {
	numberOfEvents: number;
	sourcePageOriginStatisticsTree: NetworkOriginStatisticsTree;
	destinationOriginStatisticsTree: NetworkOriginStatisticsTree;
}

export interface RecordingNetworkSummaryStatistics extends NetworkRequestStatistics {
	numberOfEvents: number;
	sourcePageRegisteredDomains: NetworkStatisticsForRequestsForRegisteredDomain[];
	destinationRegisteredDomains: NetworkStatisticsForRequestsForRegisteredDomain[];
}

export interface RecordingDataSummary extends NetworkRequestStatistics {
	numberOfEvents: number;
	sourcePageRegisteredDomains: NetworkStatisticsForRequestsForRegisteredDomain[];
	destinationRegisteredDomains: NetworkStatisticsForRequestsForRegisteredDomain[];
}export const keyForRecordingStatisticsForSourcePageAndDestinationPageUrl = ({ sourcePageUrl, destinationPageUrl }: {
	sourcePageUrl: string;
	destinationPageUrl: string;
}) => `${sourcePageUrl}\0${destinationPageUrl}` as const;
export type RecordingStatisticsForSourcePageAndDestinationPageUrlKey = ReturnType<typeof keyForRecordingStatisticsForSourcePageAndDestinationPageUrl>;

